<style lang="less" scoped>

/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
/deep/ .ivu-input-number{
    width: 100% !important;
}
.verAddCon{
    position: relative;
    .title{
        font-size: 20px;
        padding: 4px 0 20px;
    }
    .colseButton{
        position: absolute;
        right: -18px;
        top:-18px
    }
}
</style>
<template>
<div class="verAddCon"  v-if='showModel'>
        <div class="title">{{title}}</div>
        <Icon class="colseButton" type="ios-close-circle" size='30' style="color:#ed4014" @click="cancel" />
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
            <FormItem :label="$t('firmwarePlan.titleName.fwareId')" prop="fwareId"  style="width: 500px">
                <SearchSelect ref="fwaresRef" :needName="$t('firmwarePlan.titleName.fwareId')"  :selectUrlQuery="{}" :url="fwaresListUrl" labelName='id' labelNameNew="suitDeviceType" labelNameNew1="fwareVersion" isMultiple='2'  valName='id' keyword="id" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectVal($event,'fwareId')"></SearchSelect>
            </FormItem>
            <FormItem :label="$t('firmwarePlan.titleName.fwareVersion')" prop="fwareVersion" class="ivu-form-item-required" style="width: 500px">
                <Input type="text" v-model.trim="formData.fwareVersion" disabled :placeholder="$t('inputPlaceholder')" ></Input>
            </FormItem>
             <FormItem :label="$t('firmwarePlan.titleName.deviceGroupName')" prop="deviceGroup"  style="width: 500px">
                <SearchSelect ref="deviceGroupsRef" :needName="$t('firmwarePlan.titleName.deviceGroupName')" :addAll='addAll'  :url="deviceGroupsListUrl" labelName='groupName' isMultiple='2'  valName='id' keyword="groupName" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectVal($event,'deviceGroup')"></SearchSelect>
            </FormItem>

             <FormItem :label="$t('firmwarePlan.titleName.number')" prop="limitSize" style="width: 500px">
                <InputNumber :max="500" :min="1" :step="1" :precision="0" v-model="formData.limitSize" :placeholder="$t('inputPlaceholder')"></InputNumber>
                <div class="simple-size">{{ $t('firmwarePlan.tip.five') }}</div>
            </FormItem>

            <FormItem :label="$t('firmwarePlan.titleName.unit')" prop="intervalUnit" style="width: 500px">
                 <Select :placeholder="$t('selectPlaceholder')"  clearable class="input-div" label-in-value v-model="formData.intervalUnit" @on-change="changeUnit">
                    <Option v-for="item in selectObj.timeUnitlist" :value="item.id+''" :key="item.id">{{item.val}}</Option>
                </Select>
            </FormItem>

            <!-- <FormItem :label="$t('firmwarePlan.titleName.interval')" prop="pushInterval" style="width: 500px">
                <Select :placeholder="$t('selectPlaceholder')" filterable  clearable class="input-div" v-model="formData.pushInterval">
                    <Option v-for="item in selectObj.topVal" :value="item+''" :key="item">{{item}}</Option>
                </Select>
                <div class="simple-size">{{ $t('firmwarePlan.tip.six') }}</div>
            </FormItem> -->

            <FormItem :label="$t('firmwarePlan.titleName.interval')" prop="minNumber" style="width: 500px">
                <InputNumber :max="600" :min="1" :step="1" :precision="0" v-model="formData.minNumber" :placeholder="$t('inputPlaceholder')"></InputNumber>
                <div class="simple-size">{{ $t('firmwarePlan.tip.six') }}</div>
            </FormItem>
            
            <FormItem style="margin-top: 40px;">
                <Button :loading="disabled"  type="primary" @click="subData('formData')" style="margin-right:20px">{{$t('save')}}</Button>
                <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
            </FormItem>
    
            
          
        </Form>
    <!-- </Modal> -->
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import SearchSelect from '../../common/selectList.vue';
import { mapState } from 'vuex'
    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object,
            offModel: Boolean
        },
        name: "ModelPlan",
        components: {
            SearchSelect
        },
        data() {
            return {   
                fwaresListUrl:this.config.urlArray.fwaresList,
                deviceGroupsListUrl:this.config.urlArray.deviceGroupsList,
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                addAll:'firmwarePlan.allGroup',
                deviceGroupName:'',
                formData: {//表单数据
                    fwareId:'',
                    fwareVersion: '',
                    deviceGroup:'',
                    releaseForAllSuitype:false,
                    limitSize:1,
                    intervalUnit:'4',
                    pushInterval:'',
                    minNumber:null
                }, 
               
            }
        },
        watch:{
            showModel(val){
                if(val === true) {   
                    
                    if(this.type==1){//新增
                        this.title = this.$t('appPlan.addButton')
                        this.$nextTick(()=>{//select赋值
                            // this.$refs.fwaresRef.setQuery(null)
                            // this.$refs.deviceGroupsRef.setQuery(null)
                            this.$refs.fwaresRef.setQuery(null)
                            this.$refs.deviceGroupsRef.setQuery(null)
                        }); 
                        
                    }else if(this.type==2){
                        this.title = this.$t('appPlan.editButton')
         

                        for (let key in this.editFormData) {
                             if (this.formData.hasOwnProperty(key)) {
                                 this.formData[key] = this.editFormData[key]
                             }
                        }

                        this.formData.fwareId = this.editFormData.fwareId+''
                        this.formData.limitSize = this.editFormData.limitSize*1
                        this.formData.intervalUnit = this.editFormData.intervalUnit+''
                        this.formData.pushInterval = this.editFormData.pushInterval+''
                        this.formData.minNumber = this.editFormData.pushInterval*1
                       

                        if(this.formData.releaseForAllSuitype){//所有组
                           this.formData.deviceGroup = '0'
                           this.deviceGroupName = this.$t('firmwarePlan.allGroup')
                            this.$nextTick(()=>{//select赋值
                                this.$refs.fwaresRef.setDefVal(Number(this.formData.fwareId));
                                this.$refs.deviceGroupsRef.setDefVal(this.formData.deviceGroup)
                            });
                        }else{
                             this.formData.deviceGroup = this.editFormData.deviceGroup+''
                             this.deviceGroupName = this.editFormData.deviceGroupName
                             this.$nextTick(()=>{//select赋值
                                this.$refs.fwaresRef.setDefVal(Number(this.formData.fwareId));
                                this.$refs.deviceGroupsRef.setDefVal(Number(this.formData.deviceGroup))
                            });

                        }

                         
                    }
                  
                } else { //关闭弹框后要做的处理
                    this.resetForm();//重置表单
                     this.$refs.fwaresRef.clearVal();
                     this.$refs.deviceGroupsRef.clearVal();
                }
            },
        },
        computed:{
            ...mapState(['local','selectId']),
            selectObj(){
                 return {
                    timeUnitlist:[
                       {id:1,val:this.$t('selectList.timeUnit.month')},
                       {id:2,val:this.$t('selectList.timeUnit.day')},
                       {id:3,val:this.$t('selectList.timeUnit.hour')},
                       {id:4,val:this.$t('selectList.timeUnit.minute')},
                       {id:5,val:this.$t('selectList.timeUnit.second')}
                    ],
                    topVal:59
                 }   
             },
             ruleCustom(){
                 return {//验证
                    fwareId: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    deviceGroup: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                        
                    ],
                    limitSize: [
                        {required: true,type:'number', message: this.$t('required'),trigger: 'blur' },
                        // {pattern: /^[1-9]\d*$/, message: this.$t('ruleCustom.positive_integer'), trigger:'blur'}
                    ],
                    intervalUnit: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    pushInterval: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    minNumber: [
                        {required: true,type:'number', message: this.$t('required'),trigger: 'blur' },
                    ],
                    
                }
             } 
        },
        created(){
           
        },
        methods: {
            changeUnit(e){
               let obj = {'1':12,'2':31,'3':23,'4':59,'5':59}
               this.formData.pushInterval = ''
               this.selectObj.topVal = obj[e.value]
            },
            setSelectVal(e,key){
                // console.log('e',e)
                this.formData[key] = e.nameVal+''
                if(key=='deviceGroup'){
                    this.deviceGroupName = e.nowData.label
                }
                if(key=='fwareId'){
                     this.formData.fwareVersion = e.selItem.fwareVersion
                }
            },
            subData(name) {//提交表单

                // console.log('this.deviceGroupName', this.formData)
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;
                        let url = ''
                        if(this.type==2){
                            this.formData.id = this.editFormData.id
                            url = this.config.urlArray.fwareplansEdit
                        }else{
                            url = this.config.urlArray.fwareplansAdd
                        }

     
                        if(this.formData.deviceGroup==0 && this.deviceGroupName){
                            this.formData.releaseForAllSuitype = true
                            this.formData.deviceGroup = ""
                        }else{
                            this.formData.releaseForAllSuitype = false
                        }

                        let params = {
                            ...this.formData,
                            dealerId:this.selectId,
                            pushInterval:this.formData.minNumber
                        }
                        this.axios.post(url,params).then((result) => {
                            
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{
                                this.disabled = false
                                if(this.formData.releaseForAllSuitype){//所有组
                                    this.formData.deviceGroup = '0'
                                    this.deviceGroupName = this.$t('firmwarePlan.allGroup')
                                    this.$nextTick(()=>{//select赋值
                                        this.$refs.fwaresRef.setDefVal(Number(this.formData.fwareId));
                                        this.$refs.deviceGroupsRef.setDefVal(this.formData.deviceGroup)
                                    });
                                }
                            })
                        
                        }).catch((err) => {
                            console.log(err)
                            // common.msg('error','提交失败',()=>{this.disabled = false;})
                            // this.disabled = false
                        });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                // this.$emit('update:showModel',false);
                // this.$emit('update:offModel',true);
                this.resetForm()
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.$emit('update:showModel',false);
                this.$emit('update:offModel',true);
                this.deviceGroupName = ''
                Object.keys(this.formData).forEach(key=>{this.formData[key]=''})
                this.formData.limitSize = 1
                this.formData.intervalUnit = '4'
                this.formData.minNumber = null
                this.formData.releaseForAllSuitype=false

                if(this.type==2){
                    delete this.formData.id
                }
                this.disabled = false;//恢复提交按钮为激活状态
            }
        }
    }
</script>